import Swiper, { Navigation, Pagination, Autoplay, Keyboard} from 'swiper';
Swiper.use([Navigation, Pagination, Autoplay, Keyboard]);

const swiperCounter = new Swiper(".js-counter", {
    loop: false,
    slidesPerView: 1,
    spaceBetween: 20,
    keyboard: {
      enabled: true
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
            spaceBetween: 20,
        },
        1024: {
            slidesPerView: 3,
            spaceBetween: 40,
        },
        1440: {
            slidesPerView: 4,
            spaceBetween: 40,
        },
    },
    navigation: {
        nextEl: ".swiper-button-next-counter",
        prevEl: ".swiper-button-prev-counter",
    },
});
